<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-upload' :tooltipText='$t("Security.uploadFile")' :click='notices' eventType='add'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-check-data-integrity' :tooltipText='$t("MML.versionCheck")' :click='notices' eventType='check'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-previous-layer' :tooltipText='$t("MML.batchRecover")' :click='notices' eventType='recover'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Alarm.refresh")' :click='notices' eventType='refresh'></e-item>
      </e-items>
    </ejs-toolbar>
      <div class="h-inputBox">
           <ejs-textbox :placeholder='$t("System.inputTip20")' @keydown.enter.native="search" v-model='input' />
      </div>
  </div>
</template>

<script>
export default {
  name: "ConfigRecoverTableButton",
    data() {
       return {
            input:'',
       }
    },
  methods: {
    notices(args) {
      this.$emit('notice', args.item.eventType);
    },
    search(){
        this.$emit('searchKey', "");
    }
  }
}
</script>

<style scoped>

</style>
